import { Toaster } from '@sportik/ui/primitives/sonner';
import { QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v8';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { ErrorBoundary } from '@/components/error/ErrorBoundary';
import { createRouter } from '@/routes/router';
import { createQueryClient } from '@/services/query-client';
import '@/styles.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('index.html is missing #root');
}

// One query client, shared by the router's loaders and the provider below
// (ADR 0016 § 1).
const queryClient = createQueryClient();
const router = createRouter(queryClient);

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <NuqsAdapter>
          <RouterProvider router={router} />
        </NuqsAdapter>
        <Toaster />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
